import styled from 'styled-components'
import { DialogBody } from 'client/components/core/Dialog'

export const ThreeDsWrapper = styled(DialogBody)`
  display: flex;
  padding: 0;
`
